module.exports = __webpack_public_path__ + "static/img/image034.2de23a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image034.png
// module id = iLff
// module chunks = 1